import { useOrganizationStore } from '../stores/useOrganizationStore';
import { resolveSupportContact, SupportContact } from '../constants/supportContact';
import { useClientOwner } from './useClientOwner';

/**
 * Support contact (name, email and calendar) for main-app surfaces: the org's
 * Client Owner, or the fixed support contact while Client Admin hasn't yet
 * marked onboarding complete.
 */
export const useSupportContact = (): SupportContact => {
  const onboardingComplete = useOrganizationStore(
    (s) => s.organization?.onboardingData?.onboarding_complete
  );
  const owner = useClientOwner();
  return resolveSupportContact(onboardingComplete, owner);
};
